import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { getPengaturanTabA11yProps } from "./PengaturanTabPanel";

interface PengaturanTabsProps {
    showUkmTab: boolean;
    showUkmAttention: boolean;
    value: number;
    onChange: (_event: React.SyntheticEvent, newValue: number) => void;
}

const pengaturanTabAlertIcon = (
    <Box
        sx={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#fa4c46",
            color: "#fa4c46",
            boxShadow: "0 0 0 2px #fff",
            "&::after": {
                position: "absolute",
                right: "16px",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                animation: "ripple 1.2s infinite ease-in-out",
                border: "1px solid currentColor",
                content: '""',
            },
            "@keyframes ripple": {
                "0%": {
                    transform: "scale(.8)",
                    opacity: 1,
                },
                "100%": {
                    transform: "scale(2.4)",
                    opacity: 0,
                },
            },
        }}
    />
);

const PengaturanTabs = ({
    showUkmTab,
    showUkmAttention,
    value,
    onChange,
}: PengaturanTabsProps) => {
    return (
        <Tabs
            value={value}
            onChange={onChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="Pengaturan tabs"
        >
            <Tab label="Informasi Akun" {...getPengaturanTabA11yProps(0)} />
            <Tab
                label="Informasi UKM"
                icon={showUkmAttention ? pengaturanTabAlertIcon : undefined}
                iconPosition="end"
                sx={{ display: showUkmTab ? undefined : "none" }}
                {...getPengaturanTabA11yProps(1)}
            />
            <Tab label="Pusat Bantuan" {...getPengaturanTabA11yProps(2)} />
        </Tabs>
    );
};

export default PengaturanTabs;
